// extracted by mini-css-extract-plugin
export default {"banner":"aboutbanner_banner__vmU41","wrapper":"aboutbanner_wrapper__Kou1M","title":"aboutbanner_title__I60rw","Image":"aboutbanner_Image__p3aeM"};